/* Package JSON Import will be here */
import React from "react";
import { getTranslate } from "react-localize-redux";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, Badge, Row, Col, PageHeader, Modal } from 'antd';
/* Package JSON Import will be here */

/* Project Import will be here */
import ProductList from "components/products/ProductList";
import {
  applyFilter,
  initializeFilter,
  getSchemeProducts,
  getNextPage,
  getOpportunitiesProducts
} from "reducers/products";
import {
  orderUpload,
  changeQuantity,
  changeCaseQuantity,
  removeAllChangedProductFromOrderReducer
} from "reducers/orders";
import {
  subCategoryRequest,
  categoryRequest,
  checkEligibleForFoc,
  errorToast,
  checkAnyFocProductsAddedInCart,
  getCultureNumberFormat
} from "utilities/utils";
import { Spinner } from "components/Spinner";
import { appRoutesConst } from 'app/navigation';
import Constants from "../../utilities/appConstants";
import ProductValue from "components/products/ProductValue";
import NoData from "../../components/reusable/NoData";
import MobileProductAttrFilter from "./filter/MobileProductAttrFilter";
import { changeFocStatus } from "reducers/common";
import modalConfirmationHook from "hooks/modalConfirmationHook";
import BulkOrderModal from "components/orders/BulkOrderModal";
import FocSwitchComp from "components/orders/FocSwitchComp";
import ScrollTop from "components/reusable/ScrollTop";
import { relevantSoOrderUpload } from "reducers/orders"
import TooltipComp from "components/reusable/TooltipComp";
import { GAShowMoreButton } from "hooks/googleAnalyticsHooks";
/* Project Import will be here */

/* Const,Let & Var will be here */
let isBottomReached = true;
const { confirm } = Modal;
/* Const,Let & Var will be here */

class Products extends React.Component {
  orderUploadOnProductValue = () => {
    this.props.actions.orderUpload();
  }

  async componentDidMount() {
    /* Check for FOC selection */
    if (this.props.appSettings.isEnableFoc) {
      if (checkEligibleForFoc(this.props.orders, true) && this.props.cart.ids.length !== 0 && checkAnyFocProductsAddedInCart(this.props.cart.data)) {
        await this.props.actions.changeFocStatus(true);
      }
    }

    /* Fetch the product list data */
    await this.getProductList();

    /* Listen product_list_container scroll event */
    if (this.props.appSettings.isLoadProductsAutomaticallyOnReachBottom) {
      document.addEventListener('scroll', this.productListTrackScrolling);
    }
  }

  componentWillUnmount() {
    /* Remove product_list_container scroll event */
    if (this.props.appSettings.isLoadProductsAutomaticallyOnReachBottom) {
      document.removeEventListener('scroll', this.productListTrackScrolling);
    }
  }

  /* Get the products based on conditions */
  getProductList = async () => {
    const { category, subcategory } = this.props.params || { category: '', subcategory: '' };
    let id = undefined;
    let filterType = this.props.common.productTab;
    const { pageType, router } = this.props;

    /* For SchemeDetails page the products are coming from the SchemeView API itself */
    if (pageType !== Constants.SCHEME_DETAILS && pageType !== Constants.BANNER_DETAILS && pageType !== Constants.VIEW_ALL_PRODUCTS) {
      /* Check for subcategory filter selected */
      if (subcategory) {
        const splittedSubCat = subcategory.split("_");
        const splittedCat = category.split("_");
        id = splittedSubCat[splittedSubCat.length - 1];
        if (id) {
          this.props.actions.applyFilter(subCategoryRequest({ id, filterType }));
          this.props.actions.initializeFilter({
            code: "CAT",
            id: splittedCat[splittedCat.length - 1]
          });
        }
      }
      /* Check for category filter selected */
      else if (category) {
        const splittedCat = category.split("_");
        id = splittedCat[splittedCat.length - 1];
        if (id) this.props.actions.applyFilter(categoryRequest({ id, filterType }));
      }
      /* Check for fav product page selected */
      else if (router.location.pathname.includes(appRoutesConst.favProducts)) {
        this.props.actions.applyFilter({ NeedFavourite: true });
      }
      /* Else check for specific tab selected */
      else {
        if (filterType === Constants.SCHEME)
          await this.props.actions.getSchemeProducts();
        else if (filterType === Constants.OPPORTUNITY)
          await this.props.actions.applyFilter({ NeedOpportunity: true });
        else if (filterType === Constants.RELEVANT)
          await this.props.actions.applyFilter({ NeedRelevant: true });
        else
          await this.props.actions.applyFilter({});

        /* Scroll to top of the page if the retailer on the any position */
        window.scrollTo(0, 0);
      }
    }
  }

  checkIsBottomReached(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  productListTrackScrolling = () => {
    const wrappedElement = document.getElementById('product_list_container');
    if (this.checkIsBottomReached(wrappedElement) && isBottomReached && this.props.products.totalCount > this.props.products.noOfItemsReceived && this.props.products.filter.IsShowShowMoreProductButton) {
      this.showMoreProducts();
    }
  };

  /* Add all the Relevant products to the cart */
  addAllRelevantProductsToCart = () => {
    /* Check for any FOC product added in the cart */
    if (this.checkForAnyFocProductAdded()) {
      confirm({
        title: this.props.translate("common.alerts.confirmation.addAllRelevantProductConfirmation", { productCount: this.props.products.count }),
        okText: this.props.translate("common.buttons.addToCart"),
        cancelText: this.props.translate("common.buttons.cancel"),
        okButtonProps: { size: "large", shape: "circle", style: { width: "100px" } },
        cancelButtonProps: { size: "large", shape: "circle", style: { width: "100px" } },
        centered: true,
        onOk: () => {
          this.props.actions.relevantSoOrderUpload();
        }
      });
    }
  };

  /* Add specific Relevant products to the cart */
  addSpecificRelevantItemsToCart = (productInfo) => {
    if (this.checkForAnyFocProductAdded())
      this.addSoProductToCart(productInfo);
  };

  checkForAnyFocProductAdded = () => {
    if (!this.props.appSettings.isEnableFoc || (this.props.appSettings.isEnableFoc && checkEligibleForFoc(this.props.orders, false))) {
      return true;
    }
    else {
      /* Check for if any products added in the cart */
      if (this.props.cart.ids.length <= 0) {
        /* Ask for clear the added products in the local */
        modalConfirmationHook(this.props.translate("common.alerts.confirmation.removedAddedFocProductInLocalStoreConfirmationTitle"),
          this.props.translate,
          (() => {
            this.props.actions.removeAllChangedProductFromOrderReducer();
            this.props.actions.changeFocStatus(false);
          }));
      }
      else {
        errorToast({
          content: this.props.translate("products.foc.focRequestValidation")
        });
      }

      return false;
    }
  }

  /* Add specific Relevant product to the cart */
  addSoProductToCart = (productInfo) => {
    /* Add the items to the in memory cart (Update the store order count state) */
    const count = productInfo.SoQty;
    const case_count = 0;
    if (count > 0 && count <= 9999) {
      this.props.actions.changeQuantity({
        count,
        id: productInfo.ProductId,
        isChanged: true
      });
      this.props.actions.changeCaseQuantity({
        case_count,
        product_id: productInfo.ProductId,
        caseChange: true
      });
    }
  }

  renderProducts = (products) => {
    const { translate, appSettings, pageType, common } = this.props;

    if (products.ids.length === 0 && products.isLoading) {
      return <Spinner message={translate("products.loading")} />
    }
    else if (products.ids.length === 0 && !products.isLoading) {
      return <NoData NoDataMessage={translate("products.noData")} />
    }
    else {
      return (
        <React.Fragment>
          {/* Relevant tab functionality */}
          {(appSettings.isEnableSO && common.productTab === Constants.RELEVANT && pageType !== Constants.SCHEME_DETAILS && pageType !== Constants.BANNER_DETAILS && pageType !== Constants.VIEW_ALL_PRODUCTS) &&
            <PageHeader
              className="relevant-value-text mb-2"
              title={`${translate("products.suggestedOrderValue")}: ${getCultureNumberFormat(products.suggestedOrderValue.toFixed(2), true)}`}
              backIcon={<TooltipComp title={translate("products.suggestedOrderValueInfoMessage")} className="pb-1">
                <i className="fa fa-info-circle fa-lg pl-1" aria-hidden="true"></i>
              </TooltipComp>
              }
              onBack={() => { /* OnBack is used for to show the i icon on the lest side of the relevant value */ }}
              extra={[
                <TooltipComp key="1" title={translate("products.productLabel.commonSoButtonHoverText")}>
                  <Button
                    className="mr-2 mt-1 font-8"
                    type="primary"
                    size="small"
                    shape="round"
                    onClick={this.addAllRelevantProductsToCart}
                  >
                    {translate("common.buttons.addSo")}
                  </Button>
                </TooltipComp>
              ]}
            />
          }

          {/* Product list functionality */}
          <ProductList
            products={products}
            orders={this.props.orders}
            pageType={this.props.pageType}
            addSpecificRelevantItemsToCart={this.addSpecificRelevantItemsToCart}
          />

          {(appSettings.isEnableScrollToTop && pageType !== Constants.SCHEME_DETAILS && pageType !== Constants.BANNER_DETAILS) &&
            <div className={pageType === Constants.VIEW_ALL_PRODUCTS ? "suggested-top-position" : ""}>
              <ScrollTop />
            </div>
          }

        </React.Fragment>
      );
    }
  }

  /* Handle show more button click */
  showMoreProducts = async () => {
    const { pageType, products, common } = this.props;

    isBottomReached = false;
    let currentPageType = null;
    if (pageType === Constants.VIEW_ALL_PRODUCTS)
      currentPageType = this.props.match.params.viewAllType;
    else if (pageType === Constants.SCHEME_DETAILS)
      currentPageType = Constants.SCHEME_DETAILS;
    else if (pageType === Constants.BANNER_DETAILS)
      currentPageType = Constants.BANNER_DETAILS;

    /* Make request to fetch next page records */
    await this.props.actions.getNextPage(products.filter.page + 1, common.productTab, currentPageType);

    isBottomReached = true;

    /* GA - track show more product event */
    if (window.isEnableGA)
      GAShowMoreButton(Constants.PLACE_ORDER_PRODUCT_LIST);
  }

  render() {
    const { products, appSettings, common, translate, pageType } = this.props;

    return (
      <div className="container">
        <React.Fragment>
          <div id="product_list_container" className="row">
            <React.Fragment>

              <Row className="w-100 pb-2">
                <Col span={16}>
                  {/* Product count section */}
                  <div>
                    {translate("products.totalProducts")}
                    <Badge className="ant-badge-green ml-1" showZero overflowCount={999} count={products.count} />
                  </div>
                </Col>

                {/* Product list icon menu list */}
                <Col span={8}>
                  <Row justify="end">
                    {/* FOC section */}
                    {(appSettings.isEnableFoc && common.productTab === Constants.ALL && pageType !== Constants.SCHEME_DETAILS && pageType !== Constants.BANNER_DETAILS && pageType !== Constants.VIEW_ALL_PRODUCTS) &&
                      <FocSwitchComp getProductList={() => this.getProductList()} />
                    }

                    {/* Bulk order upload section */}
                    {(appSettings.isEnableBulkOrderUpload &&
                      common.productTab === Constants.ALL &&
                      this.props.params &&
                      this.props.params.subcategory &&
                      products.count <= appSettings.bulkOrderProductCount &&
                      products.ids.length !== 0) &&
                      <BulkOrderModal
                        count={products.count}
                        subCat={this.props.params.subcategory}
                      />
                    }
                  </Row>
                </Col>
              </Row>

              {/* Product list section */}
              <div className="col-md-12 col-sm-12 p-0">
                <div id="productList_main_container" className="products__listing--main">
                  {this.renderProducts(products)}
                </div>
              </div>

              {/* Mobile page bottom order count and value bar */}
              <ProductValue
                orderSubmit={this.orderUploadOnProductValue}
                isFromSmartList={false}
              />
            </React.Fragment>
          </div>

          {/* Product list show more */}
          {(products.totalCount > products.noOfItemsReceived && products.filter.IsShowShowMoreProductButton) &&
            (products.ids.length !== 0 && products.isLoading ?
              (<Spinner message={translate("products.loading")} />)
              :
              (products.ids.length !== 0 && !appSettings.isLoadProductsAutomaticallyOnReachBottom &&
                (<div className="text-center">
                  <Button className="mb-5" type="primary" shape="round" size="large" onClick={this.showMoreProducts}>{translate("products.showMoreProducts")}</Button>
                </div>)
              )
            )}

          {/* Filter section */}
          {(pageType !== Constants.SCHEME_DETAILS && pageType !== Constants.BANNER_DETAILS && pageType !== Constants.VIEW_ALL_PRODUCTS) &&
            /* Product attribute and sorting filter */
            /* Display the following attribute filter only in mobile */
            <div className="nav-sm">
              <MobileProductAttrFilter attrFilterPageType={Constants.PLACE_ORDER_ATTR} />
            </div>
          }
        </React.Fragment>
      </div >
    );
  }
}

const mapStateToProps = (state) => {
  return {
    products: state.products,
    orders: state.orders,
    categoryMenu: state.categoryMenu,
    cart: state.cart,
    translate: getTranslate(state.locale),
    router: state.router,
    common: state.common,
    appSettings: state.appSettings
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        applyFilter,
        getSchemeProducts,
        initializeFilter,
        orderUpload,
        getNextPage,
        getOpportunitiesProducts,
        changeQuantity,
        changeCaseQuantity,
        changeFocStatus,
        removeAllChangedProductFromOrderReducer,
        relevantSoOrderUpload
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Products);